import { useContext } from 'react'
import { StoreContext } from '../contexts/StoreProvider';

const useShowNotification = () => {
    
  const [state, dispatch] = useContext(StoreContext);
  
  const showErrorNotification = (errorMessage) => {
    dispatch({
      type: "show-error-notification",
      payload: errorMessage,
    });
  }

  const showSuccessNotification = (successMessage) => {
    dispatch({
      type: "show-success-notification",
      payload: successMessage,
    })
  }

  return { showErrorNotification, showSuccessNotification };
}

export default useShowNotification;